import useQuizStore from "@/store/useQuizStore";

const Navigation = () => {
  const { currentStep, goToPrevious } = useQuizStore();

  const isSummary = currentStep >= 16;
  const displayStep = isSummary ? currentStep - 15 : currentStep;
  const displayTotal = isSummary ? 8 : 15;
  const progressPercentage = (displayStep / displayTotal) * 100;

  const showBackButton =
    currentStep > 1 &&
    currentStep !== 14 &&
    currentStep !== 15 &&
    currentStep !== 16;

  return (
    <nav className="sticky top-0 z-50 bg-transparent backdrop-blur-[30px] rounded-t-[18px] md:rounded-t-[22px] shrink-0">
      <div className="grid grid-cols-[1fr_auto_1fr] items-center px-4 md:px-6 py-3 md:py-4 gap-4">
        <button
          onClick={goToPrevious}
          className={`justify-self-start bg-white border-none text-green cursor-pointer p-1.5 md:p-2 rounded-xl md:rounded-[14px] transition-all hover:scale-[1.02] hover:shadow-sm ${
            showBackButton ? "visible" : "invisible"
          }`}
          aria-label="Go back"
        >
          <img
            src={`${window.template_root}/src/public/img/back.svg`}
            alt="Back"
            className="w-5 h-5 md:w-6 md:h-6 block"
          />
        </button>

        <div className="text-center flex items-center justify-center">
          <img
            src={`${window.template_root}/src/public/img/logo.svg`}
            alt="Naori"
            className="h-[25px] md:h-6 w-auto"
          />
        </div>

        <div className="justify-self-end text-xs md:text-sm text-gray">
          {displayStep} of {displayTotal}
        </div>
      </div>

      <div className="h-[3px] bg-light-gray relative mx-4 md:mx-6">
        <div
          className="h-full bg-green rounded-full transition-all duration-400 ease-[cubic-bezier(0.25,1.2,0.5,1)]"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
    </nav>
  );
};

export default Navigation;
